import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { Home, ArrowLeft } from 'lucide-react';
import { useTranslation } from '../contexts/LanguageContext';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title={t('notFound.seo.title')}
        description={t('notFound.seo.description')}
        ogUrl="/404"
      />
      
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-md"
        >
          <h1 className="text-9xl font-bold text-sky-600 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-white mb-4">
            {t('notFound.title')}
          </h2>
          <p className="text-primary-200 mb-8">
            {t('notFound.text')}
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/"
              className="flex items-center justify-center px-6 py-3 bg-sky-500 hover:bg-sky-600 text-white font-medium rounded-lg transition-colors"
            >
              <Home size={20} className="mr-2" />
              {t('notFound.backHome')}
            </Link>
            <button
              onClick={() => window.history.back()}
              className="flex items-center justify-center px-6 py-3 bg-white hover:bg-primary-50 text-sky-500 font-medium rounded-lg border border-primary-300 transition-colors"
            >
              <ArrowLeft size={20} className="mr-2" />
              {t('notFound.goBack')}
            </button>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default NotFoundPage;